import { CLAIM_STATUSES, GUARANTEE_OF_PAYMENT_STATUSES, formatDate } from '../../helpers';

export const getBoldStatusIndex = (progress) => {
  if (progress.percentage === 0) return -1;
  if (progress.percentage < 50) return 0;
  if (progress.percentage >= 50 && progress.percentage < 100) return 1;
  if (progress.percentage === 100) return 2;
};

const generateDateText = (date) => {
  const formattedDate = formatDate(date);
  return formattedDate !== 'Invalid Date' ? formattedDate : '';
};

export const generateStepDates = (statusUpdates, isGuaranteeOfPayment) => {
  const firstStepDateText = generateDateText(statusUpdates[0]?.statusChangedOn);
  const secondStepDateText = generateDateText(
    isGuaranteeOfPayment
      ? ''
      : statusUpdates.find(
          (c) =>
            c.status === CLAIM_STATUSES.VALIDATED || c.status === CLAIM_STATUSES.DECLINED
        )?.statusChangedOn
  );
  const thirdStepDateText = generateDateText(
    isGuaranteeOfPayment
      ? statusUpdates.find((c) => c.status === GUARANTEE_OF_PAYMENT_STATUSES.PAID)
          ?.statusChangedOn
      : statusUpdates.find(
          (c) =>
            c.status === CLAIM_STATUSES.DEBITED || c.status === CLAIM_STATUSES.PROCESSED
        )?.statusChangedOn
  );

  return {
    first: firstStepDateText,
    second: secondStepDateText,
    third: thirdStepDateText
  };
};

export const generateStepTexts = (
  isDraft,
  isGuaranteeOfPayment,
  isDeclined,
  latestStatusUpdate
) => {
  if (isDraft)
    return {
      first: 'Not submitted',
      second: '',
      third: ''
    };
  if (isGuaranteeOfPayment)
    return {
      first: 'Requested',
      second: '',
      third: 'Paid'
    };

  return {
    first: 'Submitted',
    second: isDeclined ? 'Declined' : 'Accepted',
    third: latestStatusUpdate === CLAIM_STATUSES.PROCESSED ? 'Accepted' : 'Reimbursed'
  };
};
